import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { Message } from './Message';

export const NothingToDisplayMessage = defineComponent({
  name: 'NothingToDisplayMessage',
  setup() {
    return function render() {
      return h(Message, { props: { type: 'info' } }, t('message.nothing-to-display'));
    };
  },
});
